<div class="container-fluid">
  <div class="d-flex flex-column flex-sm-row">
    <mat-form-field>
      <mat-icon matPrefix color="primary">search</mat-icon>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
    </mat-form-field>
    <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns" class="m-3">Afficher toutes
      colonnes</mat-slide-toggle>
    <mat-slide-toggle (change)="toggleStatusDisplay()" [checked]="displayValidated" class="m-3">Afficher les demandes
      validées</mat-slide-toggle>
  </div>
  <div id="requestGroup" [class]="tableClass">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="propertyName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom du bien</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.propertyName }}</td>
      </ng-container>
      <ng-container matColumnDef="propertyOwnerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Propriétaire</th>
        <td mat-cell *matCellDef="let row">{{ row.owner }}</td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date demande</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator"> {{ row.request.date | dateTimeFormat
          }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let row">{{ row.status }}</td>
      </ng-container>
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Message</th>
        <td mat-cell *matCellDef="let row">{{ row.request.message }}</td>
      </ng-container>
      <ng-container matColumnDef="uid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let row">{{ row.request.uid }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row" class="mobile-double-actions">
          <button mat-icon-button [routerLink]="['/property', row.request.property.uid]" appTooltip="Voir le bien">
            <mat-icon color="primary">remove_red_eye</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSize]="paging.pagingPageSize" [pageSizeOptions]="paging.pagingPageSizeOptions"
      showFirstLastButtons></mat-paginator>
  </div>
</div>


<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li *ngIf="row.request.status !== 'VALIDATED'">
        <a (click)="edit(row.request)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier la
            demande</span></a>
      </li>
      <li *ngIf="row.request.status !== 'VALIDATED'">
        <a (click)="confirmDelete(row.request)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer la demande</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>
